import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function AboutPage() {
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'http://heiliaoapp.cn/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '关于我们',
        item: 'http://heiliaoapp.cn/about',
      },
    ],
  };

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于073漫画网',
    description: '073漫画网是专注于韩国漫画的中文在线阅读平台，提供无删减、下拉式、全免费的韩漫阅读服务。',
    url: 'http://heiliaoapp.cn/about',
    inLanguage: 'zh-CN',
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="max-w-[1100px] mx-auto px-4 md:px-6 pb-20">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: '关于我们' },
              ]}
            />

            <section className="py-10 md:py-16">
              <div className="text-center mb-16">
                <p className="text-accent-400 font-label text-xs tracking-[0.2em] uppercase mb-3">
                  关于我们
                </p>
                <h1 className="text-3xl md:text-5xl font-bold font-heading text-foreground-950">
                  073漫画网
                </h1>
                <p className="mt-4 text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                  您的免费韩漫大全——无删减 · 下拉式 · 全免费
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 mb-20">
                <div className="relative overflow-hidden rounded-2xl aspect-[4/3] bg-background-100">
                  <img
                    src="https://readdy.ai/api/search-image?query=modern%20minimalist%20reading%20app%20interface%20on%20tablet%20and%20phone%20displaying%20Korean%20manhwa%20comics%20clean%20dark%20theme%20warm%20ambient%20lighting%20cozy%20reading%20environment%20editorial%20product%20photography%20soft%20shadows%20elegant%20composition&width=800&height=600&seq=about-platform-01&orientation=landscape"
                    alt="073漫画网阅读体验"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex flex-col justify-center">
                  <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-4">
                    品牌故事
                  </h2>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                    073漫画网诞生于2022年，由一群热爱韩国漫画的资深读者创建。我们深知韩漫爱好者的痛点——找不到完整资源、翻译质量参差不齐、阅读体验割裂。于是，我们决心打造一个专注韩漫的优质平台。
                  </p>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                    经过两年的发展，073漫画网已经成为中文互联网上最受欢迎的韩漫阅读平台之一。我们拥有专业的翻译团队和内容运营团队，覆盖热血少年、浪漫爱情、悬疑惊悚等全部韩漫热门分类。
                  </p>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    我们始终坚持<strong>无删减、下拉式、全免费</strong>三大原则，让每一位韩漫爱好者都能在这里找到归属。
                  </p>
                </div>
              </div>
            </section>

            <section className="py-12 md:py-16 bg-background-100 rounded-2xl px-6 md:px-12 mb-16">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-12">
                平台数据
              </h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
                <div>
                  <div className="text-4xl md:text-5xl font-bold font-label text-primary-500 mb-2">12,000+</div>
                  <p className="text-sm text-foreground-500">韩漫资源</p>
                </div>
                <div>
                  <div className="text-4xl md:text-5xl font-bold font-label text-accent-500 mb-2">890万</div>
                  <p className="text-sm text-foreground-500">月活跃读者</p>
                </div>
                <div>
                  <div className="text-4xl md:text-5xl font-bold font-label text-primary-500 mb-2">每日更新</div>
                  <p className="text-sm text-foreground-500">同步韩国最新</p>
                </div>
                <div>
                  <div className="text-4xl md:text-5xl font-bold font-label text-accent-500 mb-2">99.7%</div>
                  <p className="text-sm text-foreground-500">读者好评率</p>
                </div>
              </div>
            </section>

            <section className="mb-20">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-12">
                核心优势
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="p-6 md:p-8 rounded-2xl bg-background-100">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5">
                    <i className="ri-shield-check-line text-xl"></i>
                  </div>
                  <h3 className="text-lg font-bold font-heading text-foreground-950 mb-3">无删减正版</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    所有漫画内容均为无删减完整版，原汁原味呈现韩国漫画的每一处细节，绝不裁剪任何画面或情节。
                  </p>
                </div>
                <div className="p-6 md:p-8 rounded-2xl bg-background-100">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5">
                    <i className="ri-smartphone-line text-xl"></i>
                  </div>
                  <h3 className="text-lg font-bold font-heading text-foreground-950 mb-3">下拉式阅读</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    专为移动端优化的下拉式阅读体验，无需翻页，上下滑动即可流畅阅读完整章节内容。
                  </p>
                </div>
                <div className="p-6 md:p-8 rounded-2xl bg-background-100">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mb-5">
                    <i className="ri-flashlight-line text-xl"></i>
                  </div>
                  <h3 className="text-lg font-bold font-heading text-foreground-950 mb-3">极速更新</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    韩文版更新后24-48小时内同步上线中文翻译，追更用户第一时间看到最新章节，永不掉队。
                  </p>
                </div>
              </div>
            </section>

            <section className="py-12 md:py-16 bg-background-100 rounded-2xl px-6 md:px-12">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-10">
                商务合作
              </h2>
              <p className="text-sm md:text-base text-foreground-600 text-center max-w-2xl mx-auto mb-10 leading-relaxed">
                073漫画网欢迎各类商务合作，包括但不限于版权引进、广告投放、IP授权、品牌联名等。我们拥有890万月活跃用户，是韩漫领域最具影响力的中文平台之一。
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
                <div className="text-center p-6 rounded-xl bg-background-50">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                    <i className="ri-mail-line"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">版权合作</h3>
                  <a href="mailto:hello@heiliaoapp.cn" className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer">
                    hello@heiliaoapp.cn
                  </a>
                </div>
                <div className="text-center p-6 rounded-xl bg-background-50">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                    <i className="ri-advertisement-line"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">广告投放</h3>
                  <a href="mailto:hello@heiliaoapp.cn" className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer">
                    hello@heiliaoapp.cn
                  </a>
                </div>
                <div className="text-center p-6 rounded-xl bg-background-50">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mx-auto mb-3">
                    <i className="ri-customer-service-line"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">客服支持</h3>
                  <a href="mailto:hello@heiliaoapp.cn" className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer">
                    hello@heiliaoapp.cn
                  </a>
                </div>
              </div>
            </section>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}